import React, { useState } from 'react'
import Dropdown from 'react-bootstrap/Dropdown';

function Feeddropdown() {
    const [state, setstate] = useState("All")
    const [day, setday] = useState("Day")
    return (<>
        <div className='d-flex gap-2 w-100 justify-content-end w-100 flex-wrap'>
            <Dropdown>
                <Dropdown.Toggle className='dropdown-btn' variant="success" id="dropdown-basic" style={{ display: "flex", justifyContent: "space-between", width: "145px", border: "none", alignItems: "center", boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.25)" }}>
                    <p className='drop_heading mb-0'>{state}</p>
                </Dropdown.Toggle>

                <Dropdown.Menu className='mt-3  '>
                    <Dropdown.Item className='drop_item' style={{ fontWeight: "600" }} href="#/action-1">All</Dropdown.Item>
                    <Dropdown.Item href="#/action-2" className='drop_item'>Facebook</Dropdown.Item>
                    <Dropdown.Item href="#/action-3" className='drop_item'>Twitter</Dropdown.Item>
                    <Dropdown.Item href="#/action-3" className='drop_item' style={{ borderBottom: "none" }}>Instagram</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
            <Dropdown>
                <Dropdown.Toggle className='dropdown-btn' variant="success" id="dropdown-basic" style={{ display: "flex", justifyContent: "space-between",width: "145px", border: "none", alignItems: "center", boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.25)" }}>
                    <p className='drop_heading mb-0'>{day}</p>
                </Dropdown.Toggle>

                <Dropdown.Menu className='mt-3  '>
                    <Dropdown.Item className='drop_item' style={{ fontWeight: "600" }} href="#/action-1">Day</Dropdown.Item>
                    <Dropdown.Item href="#/action-2" className='drop_item'>Week</Dropdown.Item>
                    <Dropdown.Item href="#/action-3" className='drop_item'>Month</Dropdown.Item>
                    <Dropdown.Item href="#/action-3" className='drop_item' style={{ borderBottom: "none" }}>Year</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>








    </>

    )
}

export default Feeddropdown